import React from "react";
import { Button, Dropdown } from "semantic-ui-react";
import { PAGE_SIZE } from "../../../constants";
import "../../../css/ReactTable.css";

export const Pagination = ({
  gotoPage,
  canPreviousPage,
  canNextPage,
  previousPage,
  nextPage,
  pageIndex,
  pageOptions,
  pageCount,
  pageSize = 10,
  setPageSize
}) => {
  const options = PAGE_SIZE.map(pageSize => {
    return {
      key: pageSize,
      value: pageSize,
      text: `Show ${pageSize}`
    };
  });

  return (
    <div id="pagination">
      <div style={{ marginBottom: "1rem" }}>
        <Button
          size="mini"
          icon="angle double left"
          onClick={() => gotoPage(0)}
          disabled={!canPreviousPage}
        />
        <Button
          size="mini"
          icon="angle left"
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        />
        <Button
          size="mini"
          icon="angle right"
          onClick={() => nextPage()}
          disabled={!canNextPage}
        />
        <Button
          size="mini"
          icon="angle double right"
          onClick={() => gotoPage(pageCount - 1)}
          disabled={!canNextPage}
        />
      </div>
      <div>
        <span style={{ marginLeft: "10px" }}>
          Page{" "}
          <input
            style={{ width: "15%", marginRight: "0.5rem" }}
            type="number"
            value={pageIndex + 1 || 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
          />
          <strong>of {pageOptions.length}</strong>
        </span>{" "}
        <Dropdown
          style={{ marginLeft: "5%" }}
          button
          value={pageSize}
          options={options}
          onChange={(e, { value }) => {
            setPageSize(value);
          }}
        />
      </div>
    </div>
  );
};
